import React from 'react'

export default class ChunkErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false, error: null }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error }
    }

    componentDidCatch(error, errorInfo) {
        const isChunkError =
            error?.name === 'ChunkLoadError' ||
            error?.message?.includes('Loading chunk') ||
            error?.message?.includes('failed to fetch dynamically imported module') ||
            error?.message?.includes('dynamically imported module')

        if (isChunkError) {
            const retryKey = `chunk_retry_${window.location.pathname}`
            const lastRetry = sessionStorage.getItem(retryKey)
            const now = Date.now()

            // Si no se ha recargado automáticamente en los últimos 10 segundos, recarga la página
            if (!lastRetry || now - parseInt(lastRetry, 10) > 10000) {
                sessionStorage.setItem(retryKey, now.toString())
                window.location.reload()
            }
        }
    }

    render() {
        if (this.state.hasError) {
            const isChunkError =
                this.state.error?.name === 'ChunkLoadError' ||
                this.state.error?.message?.includes('Loading chunk')

            if (isChunkError) {
                return (
                    <div className="flex flex-col items-center justify-center min-h-[300px] p-8 text-center bg-white dark:bg-gray-800 rounded-xl m-4 shadow-sm border border-gray-100 dark:border-gray-700">
                        <div className="w-12 h-12 rounded-full bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 flex items-center justify-center text-xl mb-3">
                            🔄
                        </div>
                        <h5 className="mb-2 text-base font-bold text-gray-800 dark:text-gray-100">
                            Nueva versión de la pantalla disponible
                        </h5>
                        <p className="text-gray-500 dark:text-gray-400 mb-5 text-sm max-w-md">
                            Se actualizaron los componentes en segundo plano. Recarga la página para cargar la versión más reciente.
                        </p>
                        <button
                            type="button"
                            onClick={() => window.location.reload()}
                            className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg text-sm transition-all shadow-md"
                        >
                            Recargar página
                        </button>
                    </div>
                )
            }

            return this.props.fallback || null
        }

        return this.props.children
    }
}
